export default {
    key: 'joch-epr',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    origins: [],
    destinations: [{
        ref: 'urn:uic:stn:8507364',
        name: 'Jungfraujoch – Top of Europe',
    }],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: true,
    canSwitchDirection: false,
    canChooseReturnDestination: false,
    isUsingReductionCards: false,
    isUsingKeyCards: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: 'only',
    routeVariants: ['express', 'traditional-grin', 'traditional-laut'],
    routeVariantUp: 'default-jungfraujoch',
    routeVariantDown: 'default-jungfraujoch',
    upsells: [],
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 120,
    stayDurationMin: 30,
    maxNumberOfPeople: 9,
    maxNumberOfPeopleGroupTariff: 10,
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: true,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:listing:trips:joch-epr',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-joch-epr-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-joch-epr-steps-step-3-trip-selection',
            name: 'offerFlow.pages.stepTripSelection.name.common',
        },
        {
            routeName: 'offerFlow-joch-epr-steps-step-5-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],

} satisfies ProductConfigP2P;
